import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard, LenderObstructGuard } from '../../auth.guard';
import { BorrowerDashboardComponent } from './borrower-dashboard.component';
import { AllLoansAndApplicationsComponent } from './all-loans-and-applications/all-loans-and-applications.component';
import { UserIdResolver } from '../../resolvers/user-id.resolver';
import { PassbookComponent } from '../../passbook/passbook.component';
import { DocumentsComponent } from '../../documents/documents.component';
import { DisbursedLoanInfoComponent } from './disbursed-loan-info/disbursed-loan-info.component';
import { LoanSanctionComponent } from '../../loan-sanction/loan-sanction.component';
import { LoanIdResolver } from '../../loan-sanction/loan-id.resolver';
import { LoanProgressComponent } from '../../loan-progress/loan-progress.component';
import { PreApprovedLoanOfferComponent } from './pre-approved-loan-offer/pre-approved-loan-offer.component';
import { LoanSuggestedTermTableComponent } from './loan-suggested-term-table/loan-suggested-term-table.component';

const routes: Routes = [{
    path: '',
    component: BorrowerDashboardComponent,
    children: [
        {
            path: 'applications',
            component: AllLoansAndApplicationsComponent,
            resolve: {
                userId: UserIdResolver
            },
        },
        {
            path: 'application/:applicationId',
            canActivate: [AuthGuard, LenderObstructGuard],
            children: [{
                path: '',
                pathMatch: 'full',
                component: LoanProgressComponent,
                resolve: {
                    loanId: LoanIdResolver
                }
            }, {
                path: 'offer',
                component: LoanSanctionComponent,
                resolve: {
                    loanId: LoanIdResolver
                }
            }]
        }, {
            path: 'loan/:loanId',
            canActivate: [AuthGuard, LenderObstructGuard],
            children: [{
                path: '',
                pathMatch: 'full',
                component: DisbursedLoanInfoComponent
            }, {
                path: 'documents',
                component: DocumentsComponent,
            }, {
                path: 'passbook',
                component: PassbookComponent,
            }]
        }, {
            path: 'pre-approved-loan-offer',
            component: PreApprovedLoanOfferComponent,
            resolve: {
                userId: UserIdResolver
            }
        },
        {
            path: 'loan-suggested-term',
            component: LoanSuggestedTermTableComponent,
            resolve: {
                userId: UserIdResolver
            }
        }
    ]
}];

@NgModule({
    imports: [RouterModule.forChild(routes)],
})
export class BorrowerDashboardRoutingModule {
}
